// ─────────────────────────────────────────────────────────────────────────────
// FtueStateStore
// ─────────────────────────────────────────────────────────────────────────────
// The storage seam. Everything above it (presenter, Settings page, inspector)
// talks to this abstract class, so swapping localStorage for a user-profile API
// later is one new adapter and one line here — no consumer changes:
//
//   useFactory: () => inject(BackendFtueStateStore)
//
// The default is declared on the token rather than in AppModule so that every
// injector — app, tests, a lazily created one — resolves it without repeating
// the wiring, while an explicit `{ provide: FtueStateStore, useValue: … }` in a
// spec still overrides it.
// ─────────────────────────────────────────────────────────────────────────────

import { Injectable, inject } from '@angular/core';

import { LocalStorageFtueStateStore } from './local-storage-ftue-state.store';
import { IFtueUserState } from './ftue.models';

@Injectable({
  providedIn: 'root',
  useFactory: () => inject(LocalStorageFtueStateStore),
})
export abstract class FtueStateStore {
  /** Current user's state, or the default when nothing is stored yet. */
  abstract read(): IFtueUserState;

  /** Persists the whole state for the current user. Best-effort. */
  abstract write(state: IFtueUserState): void;
}
